export const filterAllotments = (allotments = [], searchTerm = '') => {
  if (!searchTerm) return allotments;

  const term = searchTerm.toLowerCase();
  return allotments.filter((allotment) => {
    const name = (allotment?.name || '').toLowerCase();
    const imageUrl = (allotment?.image_url || '').toLowerCase();
    return name.includes(term) || imageUrl.includes(term);
  });
};
